import script from "./form.vue?vue&type=script&setup=true&lang=ts"
export * from "./form.vue?vue&type=script&setup=true&lang=ts"

import "./form.vue?vue&type=style&index=0&id=6afa5264&lang=css"

const __exports__ = script;

export default __exports__